'use client';

import type { ButtonHTMLAttributes } from 'react';
import { Icon, type IconName } from './icon';
import { buttonClasses, type ButtonVariant } from './button-classes';

export type { ButtonVariant };

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: ButtonVariant;
  /** Densité compacte : celle des barres d'outils et des en-têtes de carte. */
  sm?: boolean;
  icon?: IconName;
};

export function Button({
  variant = 'primary',
  sm = false,
  icon,
  className,
  children,
  type = 'button',
  ...props
}: ButtonProps) {
  return (
    <button
      type={type}
      className={buttonClasses({ variant, sm, ...(className ? { className } : {}) })}
      {...props}
    >
      {icon ? <Icon name={icon} size={sm ? 16 : 18} /> : null}
      {children}
    </button>
  );
}
